import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2'
import colors from 'tailwindcss/colors'
import useDarkMode from '@fisch0920/use-dark-mode';
import Prose from "../utility/prose";

const TaxRate = () => {
    const darkMode = useDarkMode(false,{
        classNameDark: 'dark',
        classNameLight: 'light'
    });
    const brandDark = colors.sky[600] 
    const brandLight = colors.sky[400] 
    const brandDarkHover = colors.sky[500]
    const brandLightHover = colors.sky[300] 
    const text = colors.zinc[800] 
    const gridLinesDark = colors.zinc[300] 
    const gridLinesLight = colors.zinc[500] 

    const data = useStaticQuery(graphql`
        query {
            allStrapiTaxRate (sort: {fields: year, order: DESC}) {
                nodes {
                    id
                    year
                    maintenance_operations_rate
                    debt_service_rate
                    contract_rate
                    road_rate
                    order_levying_taxes {
                        localFile {
                            publicURL
                        }
                    }
                }
            }
        }
  `)

    ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
    );

    return (
        <Prose>
        <div className="w-full md:w-5/6 lg:w-2/3 mx-auto">
            {/* <Bar data={{
                labels: data.allStrapiTaxRate.nodes.map((rate) => { return (rate.year)}).reverse(),
                datasets: [
                    {
                    label: "Debt Service",
                    backgroundColor: brandLight,
                    strokeColor: brandLight,
                    hoverBackgroundColor: brandLightHover,
                    hoverStrokeColor: brandLightHover,
                    data: data.allStrapiTaxRate.nodes.map((rate) => { return (rate.debt_service_rate.toFixed(4))}).reverse()
                    },
                    {
                    label: "Maintenance and Operation",
                    backgroundColor: brandDark,
                    strokeColor: brandDark,
                    hoverBackgroundColor: brandDarkHover,
                    hoverStrokeColor: brandDarkHover,
                    data: data.allStrapiTaxRate.nodes.map((rate) => { return (rate.maintenance_operations_rate.toFixed(4))}).reverse()
                    }
                ]
                }}
                options={{
                color: darkMode.value ? '#FFF': text,
                responsive: true,
                scales: {
                    x: {
                    grid: {
                        color: darkMode.value ? gridLinesLight: gridLinesDark,
                    },
                    ticks: {
                        color: darkMode.value ? '#FFF': text,
                    },
                    stacked: true,
                    },
                    y: {
                    grid: {
                        color: darkMode.value ? gridLinesLight: gridLinesDark,
                    },
                    ticks: {
                        color: darkMode.value ? '#FFF': text,
                    },
                    stacked: true,
                    },
                },
                tooltips: {
                    mode: 'label',
                    displayColors: false,
                    callbacks: {
                        label: function(tooltipItem, data) {
                            var corporation = data.datasets[tooltipItem.datasetIndex].label;
                            var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                            var total = 0;
                            for (var i = 0; i < data.datasets.length; i++)
                                total += data.datasets[i].data[tooltipItem.index];
                            if (tooltipItem.datasetIndex != data.datasets.length - 1) {
                            //   return corporation + " : $" + valor.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                                return corporation + " : $ " + valor;
                            } else {
                                return [corporation + " : $ " + valor];
                            }
                        }
                    }
                },
                scaleBeginAtZero: true
            }} width="600" height="400" /> */}
        </div>
        <table className="w-full md:w-5/6 lg:w-2/3 mx-auto">
            <thead>
                <tr>
                    <td>Year</td>
                    <td>Debt Service</td>
                    <td>Maintenance</td>
                    <td>Total Tax Rate</td>
                    <td>Order Levying Taxes</td>
                </tr>
            </thead>
            <tbody>
                {data.allStrapiTaxRate.nodes.map(rate => (
                    <tr key={rate.id}>
                        <td>{rate.year}</td>
                        <td>$ {(rate.debt_service_rate).toFixed(2)}</td>
                        <td>$ {(rate.maintenance_operations_rate).toFixed(2)}</td>
                        <td>$ {(rate.debt_service_rate+rate.maintenance_operations_rate).toFixed(2)}</td>
                        { rate.order_levying_taxes === null ? (<td></td>) : (<td className="not-prose"><a className="inline-block bg-neutral-200 hover:bg-neutral-300 dark:bg-neutral-800 hover:dark:bg-neutral-900 px-4 py-2 rounded-full leading-none" target="_blank" rel="noreferrer noopener" href={rate.order_levying_taxes.localFile.publicURL}>Order Levying Taxes – {rate.year}</a></td>)}
                    </tr>
                ))}
            </tbody>
        </table>
        </Prose>
    )
}

export default TaxRate